import { BROWSER_TRACKING_INSTRUCTION, BROWSER_TRACKING_LIMITATION } from '../lib/browserTrackingCopy'
import { isAndroidBrowser, RUSTORE_URL } from '../lib/openInApp'
import './driver-browser-notice.css'

/** Remains visible even if the Android app banner has been dismissed. */
export default function DriverBrowserNotice() {
  const android = typeof navigator !== 'undefined' && isAndroidBrowser(navigator.userAgent)
  return (
    <aside className="driver-browser-notice" aria-label="Ограничения отслеживания в браузере">
      <strong>Отслеживание в браузере</strong>
      <p>{BROWSER_TRACKING_LIMITATION}</p>
      <p>{BROWSER_TRACKING_INSTRUCTION}</p>
      {android ? <a href={RUSTORE_URL} target="_blank" rel="noopener noreferrer">Скачать приложение в RuStore</a> : null}
    </aside>
  )
}
